
import { defineComponent, reactive, watch } from 'vue'
import { setCurrentTweet } from '../../store'
import { Person, Source } from '../../types'
import { Persons } from '../../utils/persons'
import TemplateAutoComplete from '../TemplateAutoComplete/index.vue'
import SwitchBox from '../SwitchBox/index.vue'

type State = {
  persons: Person[];
  copyLabel: string;
  text: string;
  source: Source;
}

export default defineComponent({
  components: { TemplateAutoComplete, SwitchBox },
  emits: ['tweet-message-change', 'tweet-source-change', 'template-change', 'copy', 'download'],
  setup (_, { emit }) {
    const state = reactive<State>({
      text: '',
      copyLabel: 'copiar',
      persons: Object.values(Persons),
      source: Source.iphone
    })

    watch(() => state.text, () => {
      emit('tweet-message-change', state.text)
    })

    watch(() => state.source, () => {
      emit('tweet-source-change', state.source)
    })

    function handleTweetSelect (person: Person): void {
      emit('template-change', person)
    }

    function handleDownload (): void {
      emit('download')
    }

    function handleCopy () {
      emit('copy')
      state.copyLabel = 'Copiado 🔥'
      setTimeout(() => {
        state.copyLabel = 'Copiar'
      }, 1000)
    }

    return {
      state,
      handleCopy,
      handleDownload,
      setCurrentTweet,
      handleTweetSelect,
      Source
    }
  }
})
